import React from "react";
 
const Modalxl = ({ isOpen, onClose, children }) => {

    if (!isOpen) return null;
 
    return (
        <>
        <div onClick={onClose} className="modal fade show" tabindex="-1" aria-labelledby="exampleModalLiveLabel" style={{display: 'block'}} aria-modal="true" role="dialog">
        <div  className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
              {children}
            </div>
        </div>
        </div>
        <div className="modal-backdrop fade show"></div>
        </>
    );
};
 
export default Modalxl;